/**
 * API configuration for development and production
 */

/**
 * Get the correct API base URL based on the current environment
 * In development with Netlify dev:
 *   - Vite runs on http://localhost:3002 (no functions)
 *   - Netlify dev server runs on http://localhost:8888 (has functions)
 * In production:
 *   - Single domain with functions at /.netlify/functions/
 */
export function getApiBaseUrl(): string {
  const isDev = import.meta.env.DEV

  if (isDev) {
    // In development, use the Netlify dev server (localhost:8888)
    // which has function support
    if (typeof window !== 'undefined') {
      // Check if we're already on the Netlify dev port
      if (window.location.port === '8888') {
        return window.location.origin
      }
      // If on Vite port (3002), redirect to Netlify dev server
      return 'http://localhost:8888'
    }
    return 'http://localhost:8888'
  }

  // In production, use relative paths (same domain)
  return ''
}

export function getContactFunctionUrl(): string {
  const baseUrl = getApiBaseUrl()
  return `${baseUrl}/.netlify/functions/contact`
}
